/********************************************************************************
 * Copyright (c) 2020 Cedalo AG
 *
 * This program and the accompanying materials are made available under the 
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const requireFile = (file) => {
	try {
		// eslint-disable-next-line
		return require(`${file}`);
	} catch (err) {
		/* ignore */
	}
	return undefined;
};

module.exports = requireFile;



// WEBPACK FOOTER //
// ../commons/src/requireFile.js